import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  ErrorOutlined,
  TaskAltOutlined,
  ArrowForward,
} from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../../redux/logger/logActions";
// import Courses from "./Courses";
import axios from "axios";
import LoginPage from "../../components/LoginPage";

import { basePath } from "../../util/basePath";

const VerifyEmail = () => {
  const [validUrl, setValidUrl] = useState(false);
  const param = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [isError, setIsError] = useState(null);

  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [logType, setLogType] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setIsloading(true);
    setIsError(null);
    const isValidToken = async () => {
      try {
        const data = await axios.get(
          `${basePath.url}auth/verify_email/${param.token}`
        );
        // console.log(data.data);
        if ((data.message = "success")) {
          setValidUrl(true);
          setIsloading(false);
          setIsError(null);
        } else {
          setIsloading(false);
          setIsError(data.description);
        }
      } catch (err) {
        setIsloading(false);
        setIsError(err.message);
      }
    };

    isValidToken();
  }, [param.token]);

  return (
    <div className="fullWidthWrapperMain" style={{ backgroundColor: "#fff" }}>
      {isLoading === true ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <CircularProgress />
        </div>
      ) : validUrl ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <TaskAltOutlined style={{ fontSize: "50px" }} color="success" />
          <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
            Email verified successfully
          </Typography>
          <button
            className="button secondary"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setLogType("login");
              setOpenLoginDialog((prev) => {
                return !prev;
              });
            }}
          >
            <a
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                fontSize: "14px",
                color: "#181717",
              }}
            >
              <span>Login to Your Account</span>{" "}
              <ArrowForward style={{ color: "#201f1f" }} />
            </a>
          </button>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <ErrorOutlined style={{ fontSize: 50 }} color="warning" />
          <Typography variant="h5" style={{ textAlign: "center" }}>
            Invalid Verfication Token
          </Typography>
          {/* <button
            className="button secondary"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/");
            }}
          >
            <a
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                fontSize: "14px",
              }}
            >
              <span>Explore Books</span>{" "}
              <ArrowForward style={{ color: "white" }} />
            </a>
          </button> */}
        </div>
      )}
      <LoginPage
        openLoginDialog={openLoginDialog}
        setOpenLoginDialog={setOpenLoginDialog}
        logType={logType}
        setLogType={setLogType}
      />
    </div>
  );
};

export default VerifyEmail;
